import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { lazy, useState, useEffect } from 'react';
// import loadable from '@loadable/component';
import { observer } from 'mobx-react-lite';
import { Typography, Button, Box } from '@mui/material';
import formatCurrencyByLocale from '../common/formatCurrencyByLocale';
// import ProcessPayment from '../payment/ProcessPayment';
// const ProcessPayment = loadable(() => import('../payment/ProcessPayment'));
const ProcessPayment = lazy(() => import('../payment/ProcessPayment'));
const MembershipPrice = ({ membership, currency, }) => {
    const [price, setPrice] = useState(0);
    const [paymentProcess, setPaymentProcess] = useState(false);
    const [paymentProps, setPaymentProps] = useState({});
    const formattedPrice = formatCurrencyByLocale(price, currency);
    useEffect(() => {
        if (!membership) {
            return;
        }
        if (membership.paymentPlan === 'recurring') {
            setPrice(membership.recurringPrice);
        }
        else if (membership.paymentPlan === 'installment') {
            setPrice(membership.installmentPrice);
        }
        else {
            setPrice(membership.onetimePrice);
        }
    }, [membership, membership?.syncState]);
    const startProcessPayment = () => {
        setPaymentProps({
            paymentType: 'oneTime',
            amount: price,
        });
        setPaymentProcess(true);
    };
    const getRecurringTerm = () => {
        if (membership.type === 'recurring') {
            return ` ${membership.recurringTerm}`;
        }
        return '';
    };
    return (_jsxs(Box, { children: [_jsx(Typography, { component: "div", variant: "h5", fontWeight: "fontWeightBold", sx: {
                    width: 'auto',
                    minWidth: 134,
                    paddingX: 1,
                    m: 1,
                }, children: _jsxs(Typography, { component: "span", variant: "inherit", fontWeight: "inherit", children: [formattedPrice, getRecurringTerm()] }) }), _jsx(Button, { variant: "contained", sx: {
                    m: '1em',
                }, onClick: startProcessPayment, children: "Purchase" }), paymentProcess && (_jsx(ProcessPayment, { membership: membership, paymentType: paymentProps.paymentType, amount: paymentProps.amount }))] }));
};
export default observer(MembershipPrice);
//# sourceMappingURL=MembershipPrice.js.map